<template>

    <div class="relation581">
        <van-row>
            <van-col span="16">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[0])">
                    <img src="https://cdn.edstatic.com/203012120000/6c8495396c0be991e548a1a2b6ac53ab/2025/05/327b51a8-c5af-4343-b1e7-74bbcbfdb646.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[2])">
                    <img src="https://cdn.edstatic.com/203012120000/f4f2509074f0315268c45dad091432d7/2025/05/858981e0-0763-4a83-a065-83085c977198.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[1])">
                    <img src="https://cdn.edstatic.com/203012120000/a385e015fabd8baae161d9b77cf87e28/2025/05/139e8a8d-85ec-43ae-813f-74b0a03646eb.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[3])">
                    <img src="https://cdn.edstatic.com/203012120000/24732bc200d5fe5df9aa392613ce474d/2025/05/a4433ccc-af7d-427f-a234-a55730fc16a6.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                    <img src="https://cdn.edstatic.com/203012120000/0fdcad95adf71ae15c7be5b03cb728ab/2025/05/a4528fd3-30c1-4b18-88c8-232215ac258b.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
                    <img src="https://cdn.edstatic.com/203012120000/2fc8b656daf4fcbd0143363a96561caf/2025/05/7ed9c463-15e5-4d41-9dd9-7ccb754e1c75.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="8">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
                    <img src="https://cdn.edstatic.com/203012120000/4526a560b018e1a28bd849139ef550c8/2025/05/97c0589a-43e8-46fb-bbdf-cf11cc26c796.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="16">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[7])">
                    <img src="https://cdn.edstatic.com/203012120000/21faa9fefa983744375ff77adb396b60/2025/05/42ed74f9-ba8e-4abb-9a2a-6254b1219d90.png"
                        alt="">
                </a>

                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[8])">
                    <img src="https://cdn.edstatic.com/203012120000/7a7b3b8e86feb7402dfa3b12a4ce3b71/2025/05/3aa3e1ff-1551-4aa8-babc-e9a2c6145c4e.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
    </div>

</template>
<script>
export default {
    props: {
        meetingButton: Array,
        showButtonText: Number,

    },
    data() {
        return {
            button_rows: 3,
        }
    },
    methods: { // 将 skipLink 方法移至此处
        skipLink(item) {
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.relation581 {
    // overflow: auto;
    padding: 0.3rem 0.5rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    background: #f9f8f8;

    .van-row {
        width: 100%;
        line-height: 0;

    }

    .van-col {
        line-height: 0;
    }

    div {
        text-align: center;
    }

    a {
        display: inline-block;
        text-align: center;
        line-height: 0;
        padding: 0.17rem;
        // margin-bottom: 16px;
    }

    img {
        width: 100%;
        height: 100%;

    }
}


.one-column {
    flex-direction: column;
    align-items: flex-start;
}



@media screen and (min-width: 500px) {
    .relation581 a {
        padding: 0.29rem !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Button581.vue